import styled, { css } from 'styled-components'
import arrowDown from '../../../../../assets/addStockModal/excel/arrow-down.svg'

export const InputDiv = styled.div`
    display: flex;
    padding: 0px 8px 5px 8px;
`

export const StyledSelect = styled.select`
    background-color: #ebebeb;
    color: #777777;
    height: 5.3vh;
    width: 9vw;
    padding-left: 1vw;
    padding-right: 2.4vw;
    border-radius: 2vw;
    border: 1px solid #e1e1e1;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url(${arrowDown});
    background-repeat: no-repeat;
    background-position-x: 7vw;
    background-position-y: 1.6vh;
    background-size: 18px 15px;

    :focus{
        outline: 0;
    }
`

export const StyledOption = styled.option`
    background-color: #fff;
    font-size: 0.625rem;
`